<template>
  <div>
    <el-dialog :title="titleMap[dialogStatus]" :visible.sync="dialogVisible" width="450px">
      <el-form class="post-main-container post-dialog-container" label-position="right">
        <el-form-item label="角色名：" prop="name">
          <el-input v-model="temp.name"></el-input>
        </el-form-item>

        <el-form-item label="描述：" prop="tips">
          <el-input v-model="temp.tips"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button
          v-if="dialogStatus === 'create'"
          type="primary"
          @click="createData"
          :loading="btnLoading"
        >
          创建
        </el-button>
        <el-button v-else type="primary" @click="updateData" :loading="btnLoading">
          提交信息
        </el-button>
        <el-button @click="dialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { updateRole } from '@/api/admin'

export default {
  data() {
    return {
      dialogStatus: 'create',
      dialogVisible: false,
      btnLoading: false,

      titleMap: {
        create: '创建角色',
        update: '编辑角色'
      },

      temp: {
        code: '',
        name: '',
        tips: '',
        pid: 0,
        deptId: 0
      }
    }
  },

  created() {
    this.emptyTemp = JSON.parse(JSON.stringify(this.temp))
  },

  methods: {
    handleCreate() {
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogVisible = true
    },

    handleUpdate(row) {
      console.log('row.... :>> ', row)
      this.copyTemp(row)
      this.dialogStatus = 'update'
      this.dialogVisible = true
    },

    createData() {
      this.btnLoading = true

      updateRole(this.temp, 'create')
        .then(() => {
          this.btnLoading = false
          this.dialogVisible = false

          this.$message.success('新增角色成功')
          this.$emit('listenPostSuccess')
        })
        .catch(() => {
          this.btnLoading = false
        })
    },

    updateData() {
      this.btnLoading = true

      updateRole(this.temp, 'update')
        .then(() => {
          this.btnLoading = false
          this.dialogVisible = false

          this.$message.success('提交角色信息成功')
          this.$emit('listenPostSuccess')
        })
        .catch(() => {
          this.btnLoading = false
        })
    },

    resetTemp() {
      this.temp = Object.assign(this.temp, this.emptyTemp)
    },

    copyTemp(row) {
      this.temp.code = row.code
      this.temp.name = row.name
      this.temp.tips = row.tips
      this.temp.pId = 0
      this.temp.deptId = 0
    }
  }
}
</script>
